<div class="boxWhite">
    <h4>CAMBIAR SUCURSAL CB</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-auto">
                <h6 class="clBlack">ID</h6>
                <p class="clGray mb-4">{{getConductor.visibleId}}</p>
            </div>
            <div class="col-sm">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{getConductor.nombres}} {{getConductor.apellidoPaterno}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>SUCURSAL ORIGEN</h6>
                        <p class="clRed m-0 fw-medium">{{getConductor.jornadaEnCurso.sucursal.nombre}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>SUCURSAL ACTUAL</h6>
                        <p class="clRed m-0 fw-medium">{{getConductor.sucursalActual.nombre}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mb-4">
                <!-- listadoSucursalesDisponibles -->
                <ng-select placeholder="SELECCIONE TERMINAL" [(ngModel)]="sucursalSeleccionada" [multiple]="false"
                    bindLabel="nombre" [items]="listaSucursales">
                </ng-select>
            </div>
        </div>

    </div>
    <div class="footModal">
        <button *ngIf="tienePermisoCambiarSucursal()" class="btn btnGray w-100" (click)="cambiarSucursal()">CAMBIAR SUCURSAL</button>
    </div>
</div>